import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { Direction } from '@yandex-lego/components/Popup/desktop';
import HintPopup from 'client/components/hint-popup';

import './index.css';

const b = cn('help');

interface Props {
    content: string;
    mix?: string;
    mixPopup?: string;
    width?: number;
    showCopyButton?: boolean;
    directions?: Direction[];
}

interface State {
    visibleHint: boolean;
}

const DIRECTIONS: Direction[] = ['top-left', 'bottom-left', 'top-right', 'bottom-right', 'bottom-center', 'top-center'];

class Help extends Component<Props, State> {
    private nodeRef = React.createRef<HTMLDivElement>();

    constructor(props: Props) {
        super(props);

        this.state = {
            visibleHint: false
        };
    }

    render() {
        const {
            content,
            showCopyButton,
            mix,
            mixPopup,
            directions = DIRECTIONS
        } = this.props;
        const { visibleHint } = this.state;

        return (
            <div
                className={b('', [mix])}
                ref={this.nodeRef}
                onMouseEnter={this.openPopup}
                onMouseLeave={this.closePopup}
                onTouchEnd={this.togglePopup}
                >
                <i
                    className={b('icon')}
                    >
                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ pointerEvents: 'none' }}>
                        <path d="M10.137 17.797a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M9.512 9.672h.625v4.375h.625" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M9.98 7.797a.938.938 0 1 0 0-1.875.938.938 0 0 0 0 1.875Z" fill="currentColor" />
                    </svg>
                </i>

                <HintPopup
                    visible={visibleHint}
                    anchor={this.nodeRef}
                    mixClassName={b('hint', [mixPopup])}
                    content={content}
                    showCopyButton={showCopyButton}
                    directions={directions}
                    />
            </div>

        );
    }

    private closePopup = () => {
        if (this.state.visibleHint) {
            this.setState({ visibleHint: false });
        }
    }

    private openPopup = () => {
        this.setState({ visibleHint: true });
    }

    private togglePopup = () => {
        this.setState({ visibleHint: !this.state.visibleHint });
    }
}

export default Help;
